export default "__VITE_ASSET__Cxz5xezm__"